module.exports = __webpack_public_path__ + "img/mp.9b010e92.png";